<template>
	<div>
		<div v-if="loggedIn" class="min-h-screen bg-gray-100 background bg-blend-overlay">
			<div>
				<Popover v-slot="{ open }" as="header" class="pb-24 mb-5 p-3 mt-8 lg:mt-1">
					<div class="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-(--breakpoint-2xl) lg:px-8 mb-8">
						<div class="relative flex flex-wrap items-center justify-center lg:justify-between">
							<!-- Logo -->
							<div class="absolute left-0 py-5 shrink-0 hover:cursor-pointer lg:static">
								<a @click="HomeClicked">
									<img class="h-12 w-auto" src="./assets/Logo.svg" alt="Workflow" />
								</a>
							</div>

							<!-- Right section on desktop -->
							<div class="hidden lg:ml-4 lg:flex lg:items-center lg:py-5 lg:pr-0.5 p-8">
								<!-- Profile dropdown -->
								<Menu as="div" class="ml-4 relative shrink-0">
									<div class="flex-initial">
										<MenuButton
											class="bg-white rounded-full flex text-sm ring-2 ring-green-500 ring-opacity-40 focus:outline-hidden focus:ring-opacity-100 p-1"
										>
											<span class="sr-only">Open user menu</span>
											<UserCircleIcon class="h-8 w-8 rounded-full" />
											<div class="flex-1 mt-1 mr-2">{{ user.name }}</div>
										</MenuButton>
									</div>
									<transition
										leave-active-class="transition ease-in duration-75"
										leave-from-class="transform opacity-100 scale-100"
										leave-to-class="transform opacity-0 scale-95"
									>
										<MenuItems
											class="origin-top-right z-40 absolute -right-2 mt-2 w-64 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-hidden"
										>
											<MenuItem v-for="item in userNavigation" :key="item.name">
												<a
													:href="item.href"
													:class="[
														'block px-4 py-2 text-base text-gray-800 hover:bg-gray-100 focus:bg-gray-400',
														item.separator
															? 'border-grey-200 border-t mt-2 border-dashed font-medium'
															: ''
													]"
													@click="
														() => {
															navigationClick(item)
														}
													"
													>{{ item.name }}</a
												>
											</MenuItem>
										</MenuItems>
									</transition>
								</Menu>
							</div>

							<!-- Menu button -->
							<div class="absolute right-0 shrink-0 lg:hidden">
								<!-- Mobile menu button -->
								<PopoverButton
									class="bg-transparent p-2 rounded-md inline-flex items-center justify-center text-green-200 hover:text-green hover:bg-white hover:bg-opacity-10 focus:outline-hidden focus:ring-2 focus:ring-green"
								>
									<span class="sr-only">Open main menu</span>
									<Bars3Icon
										v-if="!open"
										class="block h-8 w-8 text-green-600 focus:outline-hidden focus:ring-2 focus:ring-green"
										aria-hidden="true"
									/>
									<XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
								</PopoverButton>
							</div>
						</div>
					</div>

					<TransitionRoot as="template" :show="open">
						<div class="lg:hidden">
							<TransitionChild
								as="template"
								enter="duration-150 ease-out"
								enter-from="opacity-0"
								enter-to="opacity-100"
								leave="duration-150 ease-in"
								leave-from="opacity-100"
								leave-to="opacity-0"
							>
								<PopoverOverlay static class="z-20 fixed inset-0 bg-black bg-opacity-25" />
							</TransitionChild>

							<TransitionChild
								as="template"
								enter="duration-150 ease-out"
								enter-from="opacity-0 scale-95"
								enter-to="opacity-100 scale-100"
								leave="duration-150 ease-in"
								leave-from="opacity-100 scale-100"
								leave-to="opacity-0 scale-95"
							>
								<PopoverPanel
									focus
									static
									class="z-30 absolute top-0 inset-x-0 max-w-5xl mx-auto w-full p-2 transition transform origin-top"
								>
									<div
										class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y divide-gray-200"
									>
										<div class="pt-3 pb-2">
											<div class="flex items-center justify-between px-4">
												<div>
													<img
														class="h-8 w-auto"
														:src="require('./assets/Logo.svg')"
														alt="Workflow"
													/>
												</div>
												<div class="-mr-2">
													<PopoverButton
														class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-cyan-500"
													>
														<span class="sr-only">Close menu</span>
														<XMarkIcon class="h-6 w-6" aria-hidden="true" />
													</PopoverButton>
												</div>
											</div>
											<!-- <div class="mt-3 px-2 space-y-1">
												<a
													v-for="item in navigation"
													:key="item.name"
													:href="item.href"
													class="
														block
														rounded-md
														px-3
														py-2
														text-base text-gray-900
														font-medium
														hover:bg-gray-100 hover:text-gray-800
													"
													>{{ item.name }}</a
												>
											</div> -->
										</div>
										<div class="pt-4 pb-2">
											<div class="flex items-center px-5 p-8">
												<span>{{ user.name }}</span>
												<div class="shrink-0">
													<UserCircleIcon class="h-8 w-8 rounded-full" />
												</div>
												<button
													class="ml-auto shrink-0 bg-white p-1 text-gray-400 rounded-full hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
												>
													<span class="sr-only">View notifications</span>
												</button>
											</div>
											<div class="mt-3 px-2 space-y-1">
												<a
													v-for="item in userNavigation"
													:key="item.name"
													:href="item.href"
													class="block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800"
													>{{ item.name }}</a
												>
											</div>
										</div>
									</div>
								</PopoverPanel>
							</TransitionChild>
						</div>
					</TransitionRoot>
				</Popover>

				<router-view />

				<footer>
					<div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
						<div>
							<div class="container mx-auto p-8">
								<div class="grid grid-flow-col auto-cols-auto">
									<div>
										<h2
											class="text-3xl text-white border-yellow-300 block mb-10 border-b-2 p-4 max-w-xs"
										>
											Windpark
										</h2>
										<p class="p-4">
											<img
												loading="lazy"
												class="m-4 alignnone size-full wp-image-1826"
												src="./assets/Logo.svg"
												alt=""
												width="200"
												height="59"
											/>
										</p>
									</div>
									<div class="text-white">
										<h2
											class="text-3xl text-white border-yellow-300 block mb-10 border-b-2 p-4 max-w-xs"
										>
											Contact
										</h2>
										<p class="p-4">
											<span class="font-bold text-yellow-300 uppercase">Algemeen</span><br />
											<a href="https://windparkzeewolde.nl/contact/">Contactformulier</a><br />
											<span class="font-bold text-yellow-300 uppercase">T </span>036 84 51 688
										</p>
										<p class="p-4">
											<span class="font-bold text-yellow-300 uppercase">Privacy disclaimer</span
											><br />
											<a
												href="https://windparkzeewolde.nl/wp-content/uploads/2023/02/Privacyverklaring-windpark-zeewolde.pdf"
												target="_blank"
												rel="noopener"
												>Klik hier</a
											>
										</p>
									</div>
									<div class="col-md-4 nieuwsbrief">
										<!-- <p class="green">Blijf op de hoogte van het laatste nieuws.</p> -->
									</div>
								</div>
							</div>
						</div>
						<div class="border-t border-gray-200 py-8 text-sm text-white text-center">
							<span class="block sm:inline">&copy; 2023 Windpark Zeewolde BV</span>
						</div>
					</div>
				</footer>
			</div>
		</div>
		<ChangeEmailDialog ref="emailPrompt" />
		<ChangeTelephoneNumberDialog ref="telefoonnummerPrompt" />
		<ChangePasswordDialog ref="passwordPrompt" />
		<TwoFADialog ref="twoFactorPrompt" />
		<router-view v-if="!loggedIn" />
	</div>
</template>
<script lang="ts">
import {
	Menu,
	MenuButton,
	MenuItem,
	MenuItems,
	Popover,
	PopoverButton,
	PopoverOverlay,
	PopoverPanel,
	TransitionChild,
	TransitionRoot
} from '@headlessui/vue'

import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'
import { UserCircleIcon } from '@heroicons/vue/24/solid'
import ChangeTelephoneNumberDialog from '@/components/ChangeTelephoneNumberDialog.ts.vue'
import ChangeEmailDialog from '@/components/ChangeEmailDialog.ts.vue'
import ChangePasswordDialog from '@/components/ChangePasswordDialog.ts.vue'
import TwoFADialog from '@/components/2FADialog.ts.vue'

const userNavigation = [
	{ name: 'Telefoonnummer veranderen', href: '#', id: 2 },
	{ name: 'Email veranderen', href: '#', id: 3 },
	{ name: 'Wachtwoord veranderen', href: '#', id: 4 },
	{ name: 'Tweefactorauthenticatiebeheer ', href: '#', id: 5 },
	{ name: 'Afmelden', href: '#', id: 1, separator: true }
]

export default {
	components: {
		Menu,
		MenuButton,
		MenuItem,
		MenuItems,
		Popover,
		PopoverButton,
		PopoverOverlay,
		PopoverPanel,
		TransitionChild,
		TransitionRoot,
		Bars3Icon,
		XMarkIcon,
		UserCircleIcon,
		ChangeTelephoneNumberDialog,
		ChangeEmailDialog,
		ChangePasswordDialog,
		TwoFADialog
	},
	setup() {
		return {
			userNavigation
		}
	},
	computed: {
		loggedIn() {
			return this.$store.getters.isLoggedIn
		},
		user() {
			return this.$store.getters.getCurrentUser
		},
		baseURL() {
			if (import.meta.env) {
				return import.meta.env.BASE_URL
			}
			return '#'
		}
	},
	methods: {
		navigationClick(c: any) {
			switch (c.id) {
				case 1:
					this.$store.commit('setCurrentUser', {})
					this.$router.push('/login')
					break
				case 2:
					//e.preventDefault()
					this.$refs.telefoonnummerPrompt.showDialog()
					break
				case 3:
					//e.preventDefault()
					this.$refs.emailPrompt.showDialog()
					break
				case 4:
					//e.preventDefault()
					this.$refs.passwordPrompt.showDialog()
					break
				case 5:
					//e.preventDefault()
					this.$refs.twoFactorPrompt.showDialog()
					break
			}
		},
		IdentityClicked() {
			this.$router.push('/identity-validation')
		},
		HomeClicked() {
			this.$router.push('/')
		}
	}
}
</script>
<style>
footer {
	background-image: url('./assets/footer.jpg');
	/* background-attachment: fixed; */
	background-repeat: no-repeat;
	background-size: cover;
}
.background {
	background-image: url('./assets/windmill.jpg');
	background-attachment: fixed;
	background-repeat: no-repeat;
	background-size: cover;
}
</style>
